
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ramp",
      function () {
        return require("private-next-pages/ramp.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ramp"])
      });
    }
  